"use client";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import calendarLight from "@/assets/images/icons/calendar-light.svg";
import locationMarkerLight from "@/assets/images/icons/location-marker-light.svg";
import { CircularDiv, CustomDiv, InlineDiv } from "@/common/divs";
import { AlmostBoldText, LightText, SemiBoldText } from "@/common/texts";
import { useHasPendingBookings } from "@/hooks/useHasPendingBookings";
import { NEUTRO_TITLES_COLOR, PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const FinishBooking: React.FC = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const { pendingBookingsState, isLoading } = useHasPendingBookings();

  if (isLoading) {
    return null;
  }

  return pendingBookingsState.length > 0 ?
      <CustomDiv
        className="global-padding"
        paddingY="56px"
        paddingX="108px"
        style={{ position: "relative" }}
        background="#FFF7E4"
      >
        <AlmostBoldText fontSize="24px">
          {t("landing.finish_booking")}
        </AlmostBoldText>
        <InlineDiv
          style={{ flexDirection: "column", gap: "20px", marginTop: "20px" }}
        >
          {pendingBookingsState.map((booking, index) => (
            <InlineDiv
              className="finish-booking-layout card-booking-container"
              onClick={() => {
                router.push(`/activity/${booking.id}/booking`);
              }}
              key={index}
            >
              <img
                className="image-booking"
                src={booking.activity_image}
                alt={booking.activity_image}
              />
              <InlineDiv
                style={{
                  justifyContent: "space-between",
                  width: "100%",
                  paddingRight: "20px",
                }}
              >
                <CustomDiv paddingX="20px" paddingY="10px">
                  <CircularDiv
                    background={PRIMARY_BUTTON_COLOR}
                    height="32px"
                    paddingX="16px"
                    width="fit-content"
                  >
                    <SemiBoldText
                      fontSize="14px"
                      color={NEUTRO_TITLES_COLOR}
                      style={{ marginTop: "-4px" }}
                    >
                      {booking.subcategory ? booking.subcategory : "Actividad"}
                    </SemiBoldText>
                  </CircularDiv>

                  <CustomDiv style={{ marginTop: "20px" }}>
                    <AlmostBoldText
                      fontSize="18px"
                      style={{ lineHeight: "1px" }}
                    >
                      {booking.activity_name}
                    </AlmostBoldText>
                    <InlineDiv
                      className="hide-icons"
                      style={{ marginTop: "8px" }}
                    >
                      <Image
                        src={locationMarkerLight.src}
                        className="place-icon"
                        width={20}
                        height={20}
                        alt="location"
                        style={{ height: "20px", width: "20px" }}
                      />

                      <LightText style={{ marginTop: "-2px" }}>
                        {" "}
                        <AlmostBoldText>
                          {t("activity.details.location")}:{" "}
                        </AlmostBoldText>
                        {booking.place}
                      </LightText>
                    </InlineDiv>
                    <InlineDiv
                      className="hide-icons-2"
                      style={{ marginTop: "8px" }}
                    >
                      <Image
                        src={calendarLight.src}
                        className="calendar-icon my-bookings-image-card"
                        width={20}
                        height={20}
                        alt="calendar"
                      />
                      <LightText style={{ marginTop: "-3px" }}>
                        {" "}
                        <AlmostBoldText>
                          {t("activity.schedule.dates")}:{" "}
                        </AlmostBoldText>
                        {booking.date_and_hour}
                      </LightText>
                    </InlineDiv>
                  </CustomDiv>
                </CustomDiv>
                <SemiBoldText
                  style={{ alignSelf: "center", minWidth: "fit-content" }}
                  fontSize="20px"
                >
                  {booking.total_price.toString().replace(".", ",")} €
                </SemiBoldText>
              </InlineDiv>
            </InlineDiv>
          ))}
        </InlineDiv>
      </CustomDiv>
    : null;
};

export default FinishBooking;
